/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { MULTICALL_ADDRESSES } from '../helpers/contracts';
import { FaEthereum } from 'react-icons/fa';
export var GetETHBalance = createPlugin({
    protocol: 'UTILITY',
    type: 'GETTER',
    description: 'Get native token balance',
    method: 'getEthBalance',
    name: 'getETHBalance',
    supportedContracts: MULTICALL_ADDRESSES,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                address: new FctAddress({ isPreview: true, icon: FaEthereum }),
            },
        },
        output: {
            balance: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
        },
    }); },
    initParams: {},
});
